import styled from 'styled-components';
import { COLORS, SHADOWS } from '@/theme';
import { Input, Select, DatePicker } from '@/ui';

export const StyledFilterRow = styled.tr`
  &&& {
    th {
      background-color: ${COLORS.GREY94};
      padding: 1rem 0.5rem;
    }
    th:last-child {
      border-right: none;
    }
  }
`;

export const StyledInput = styled(Input)`
  box-shadow: ${SHADOWS.BOTTOM} !important;
`;

export const StyledDatePicker = styled(DatePicker)`
  box-shadow: ${SHADOWS.BOTTOM} !important;
  height: 2rem;
`;

export const StyledSelect = styled(Select)`
  box-shadow: ${SHADOWS.BOTTOM} !important;
`;
